import { t } from 'i18next'

import { Service } from '@/models/service'

export const getServiceLimitReachedMessage = ({
  groupName,
  service,
}: {
  groupName?: string
  service: Service
}) => {
  const hasReachedGroupLimit =
    service.groupMaximumQnt === Infinity
      ? false
      : (service.groupAvailableQnt ?? 0) < 1 ||
        (service.groupMaximumQnt ?? 0) - (service.groupReservedQnt ?? 0) < 1
  if (service.serviceGroupId && hasReachedGroupLimit) {
    return t('map.elementDetail.serviceGroupLimitReached', { groupName })
  }
  const hasReachedGlobalLimit =
    service.globalMaximumQnt === Infinity
      ? false
      : (service.globalAvailableQnt ?? 0) < 1 ||
        (service.globalMaximumQnt ?? 0) - (service.globalReservedQnt ?? 0) < 1
  if (service.serviceGroupId && hasReachedGlobalLimit) {
    return t('map.elementDetail.serviceGlobalLimitReached')
  }
  return t('map.elementDetail.maximumServiceLimitReached')
}
